import * as React from 'react'
import styled from 'styled-components'
import { Color } from '../../../constants/app.constant'

interface Props {
  size?: number
  top: number
  right: number
  onClick?(e: React.MouseEvent<HTMLElement>): void
}

const CloseButton: React.SFC<Props> = ({
  size = 40,
  top = 10,
  right = 10,
  onClick,
}) => <Wrapper size={size} top={top} right={right} onClick={onClick} />

const Wrapper = styled.div<{ size: number; top: number; right: number }>`
  position: absolute;
  top: ${({ top }) => `${top}px`};
  right: ${({ right }) => `${right}px`};
  text-align: center;
  width: ${({ size }) => `${size}px`};
  height: ${({ size }) => `${size}px`};
  border-radius: 50%;
  border: 1px solid ${Color.WHITE};
  background-color: ${Color.BLACK};
  &::before,
  &::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    display: block;
    width: ${({ size }) => `${size / 2}px`};
    height: 2px;
    background-color: ${Color.WHITE};
  }
  &::before {
    transform: translate(-50%, -50%) rotate(45deg);
  }
  &::after {
    transform: translate(-50%, -50%) rotate(-45deg);
  }
`

export default CloseButton



// WEBPACK FOOTER //
// ./src/components/atoms/close-button/close-button.tsx